import { render, staticRenderFns } from "./02-Contact.vue?vue&type=template&id=f01d8df2&"
import script from "./02-Contact.vue?vue&type=script&lang=js&"
export * from "./02-Contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports